import { MutationTree } from 'vuex'
import ErrorState from "@/store/modules/error/ErrorState"

export const mutations: MutationTree<ErrorState> = {
  setError (state, error) {
    state.error = error
  }
}
